import React, { Component } from 'react';
import { ButtonPrimary, MeatballMenu } from 'ui';
import { CodetableListComponentProps } from 'app/area/codetable/list/list-items/types';
import { SearchFilters } from 'app/area/search-filters/search-filters';
import { UserGroupCodeModal } from './user-group-code-modal';
import { UserGroupListContent } from 'app/area/codetable/list/list-renderer/screens/user-group/user-group-list-content';
import { CodetableListDragPreview } from 'app/area/codetable/list/list-items/drag-and-drop/codetable-drag-preview';
import { MergeCodeContainer } from 'app/area/codetable/common/merge-code/merge-code-container';
import { actionCreators } from 'app/area/codetable/common/codetable-options-handler/actions';
import { regenerateAggregatedTablesEndpoint } from 'app/area/codetable/list/constants';
import styles from './user-group-list-component.scss';

export type UserGroupListComponentProps = CodetableListComponentProps & typeof actionCreators;
export class UserGroupListComponent extends Component<UserGroupListComponentProps> {

  private displayRegenerateAggregatedTables = () =>
    this.props.displayRegenerateAggregatedTables(
      regenerateAggregatedTablesEndpoint(this.props.metadata?.codetable?.id),
      this.props.metadata?.label
    );

  public render() {

    const { breadcrumbs, codetableId,
      metadata: { features: { hierarchy: isHierarchy } = {} } = {},
      codeAccessConfiguration: { canCreate, isCentralAdmin } = {}, codetableOptions,
      translation, loadCodetableOptions } = this.props;

    const rightToolbar = <>
      {canCreate && <UserGroupCodeModal
        label={translation.add_new}
        codetableId={codetableId}
        breadcrumbs={breadcrumbs}
        parentId={undefined}
        codetableOptions={codetableOptions}
        loadCodetableOptions={loadCodetableOptions}
        ButtonComponent={ButtonPrimary}
        translation={translation}
      />}
      {isHierarchy && isCentralAdmin && <div className={styles.meatball}>
        <MeatballMenu closeAfterClick={true}>
          <li>
            <button className="dropdown-item"
              id={'regenerate-aggregated-tables'}
              onClick={this.displayRegenerateAggregatedTables}>
              {translation.regenerate_aggregated_tables}
            </button>
          </li>
        </MeatballMenu>
      </div>}
    </>;

    return <SearchFilters {...this.props} rightToolbar={rightToolbar}>
      <CodetableListDragPreview {...this.props} wrappedComponent={UserGroupListContent} />
      <MergeCodeContainer {...this.props} />
    </SearchFilters>;
  }
}
